import 'bootstrap/dist/css/bootstrap.min.css';
import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import Games from '../../Components/Games/Games';
import Nocall from '../../Components/Nocall/Nocall';

function Nodashboard() {
  return (
    <div id='dashboard'>
        <div className='dashboardContainer'>
            <DashboardNavbar />
            <Nocall />
            <Games />
        </div>
    </div>
  );
}

export default Nodashboard;
